// src/components/Avatar.js
import React from "react";
import { avatarColorFor } from "../styles/designTokens";

/** Small initials avatar, colored deterministically per person so the same person always reads the same color across the app. */
const Avatar = ({ firstName, lastName, size = 40 }) => {
  const initials = `${(firstName || "?")[0] || ""}${(lastName || "")[0] || ""}`.toUpperCase();
  return (
    <div
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        borderRadius: "50%",
        backgroundColor: avatarColorFor(`${firstName}${lastName}`),
        color: "#fff",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontWeight: 700,
        fontSize: size * 0.4,
        flexShrink: 0,
      }}
    >
      {initials}
    </div>
  );
};

export default Avatar;
